import { useTheme } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';

import ContactUsSection from './ContactUsSection';
import LogoSection from './LogoSection';
import LogoutSection from './LogoutSection';
import ProfileSection from './ProfileSection';
import ReportSection from './ReportSection';
import LoginSection from './LoginSection';

import Reports from './Reports';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { Navigate, Route, Routes } from 'react-router-dom';

interface HeaderProps {
  transparent: boolean;
}

const Header = (props: HeaderProps) => {
  const theme = useTheme();
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);

  return authStatus != 'authenticated' ?(
    <>
    <AppBar
      elevation={2}
      position="fixed"
      sx={{
        backgroundColor: '#FFFFFF'
      }}
    >
      <Toolbar>
        <LogoSection />
        <Box flexGrow={1} />
        <ReportSection />
        <LoginSection/>
        <ContactUsSection />
      </Toolbar>
    </AppBar>
    <Toolbar />
  </>
  ):(
    <>
      <AppBar
        elevation={2}
        position="fixed"
        sx={{
          backgroundColor: '#FFFFFF'
        }}
      >
        <Toolbar>
          <LogoSection />
          <Box flexGrow={1} />
          <ReportSection />
          <Reports/>
          <ProfileSection />
          <LogoutSection />
          <ContactUsSection />
        </Toolbar>
      </AppBar>
      <Toolbar />
    </>
  );
};

export default Header;
